export const MANAGE_PUBLIC_ORIGIN = 'https://xuetuwuyou.cn';
export const LOGIN_ENTRY_PATH = '/login';

export function buildManageLoginEntryUrl(redirectPath = '', origin = MANAGE_PUBLIC_ORIGIN) {
  const url = new URL(LOGIN_ENTRY_PATH, origin);
  const redirect = String(redirectPath || '').trim();
  if (redirect) url.searchParams.set('redirect', redirect);
  return url.toString();
}

export function resolvePostLoginRoute(redirectValue, fallback = '/dashboard') {
  const text = String(redirectValue || '').trim();
  if (!text) return fallback;
  if (!text.startsWith('/')) return fallback;
  if (text.startsWith('//')) return fallback;
  return text;
}
